var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTutorials(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.933 0a5.302 5.302 0 014.935 3.29c.266.648.402 1.342.398 2.043 0 1.587-.564 2.967-1.631 3.986l-.164.155v.001c-.593.561-1.405 1.33-1.405 1.992v.8a.533.533 0 01-.533.533h-.8a.267.267 0 01-.267-.267V8.626a.267.267 0 01.171-.249c.308-.125.6-.285.872-.477a.533.533 0 00-.618-.867c-.248.174-.723.434-.958.434s-.71-.259-.957-.434a.533.533 0 10-.62.867c.272.192.565.353.873.478a.267.267 0 01.17.25v3.905a.267.267 0 01-.266.267h-.8a.533.533 0 01-.533-.533v-.8c0-.679-.821-1.448-1.422-2.01l-.145-.136C1.195 8.341.6 6.887.6 5.333A5.32 5.32 0 015.933 0zm1.6 13.333h-3.2a.533.533 0 000 1.067h3.2a.533.533 0 100-1.067zm-.534 1.6H4.866a.533.533 0 100 1.067H7a.533.533 0 000-1.067z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTutorials);
export default "/_next/static/images/5b23e9a659b16b96a702a163757ab8bc.svg";
export { ForwardRef as ReactComponent };